import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const mistakes = [{
  title: 'El error del estiramiento',
  description: 'Te dijeron que estiraras, pero estirar un nervio irritado es como tirar de una cuerda pelada; solo causas más inflamación.'
}, {
  title: 'Las pomadas de calor',
  description: 'El calor dilata los vasos sanguíneos en un espacio que ya está apretado, aumentando la presión sobre el nervio.'
}, {
  title: 'El descanso total',
  description: 'Quedarse en cama debilita tus músculos de soporte y hace que el disco herniado se vuelva más rígido.'
}, {
  title: 'Dependencia química',
  description: 'Las pastillas solo apagan la alarma del incendio, pero no apagan el fuego que está aplastando tu nervio.'
}];
export function MistakesSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-92">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-charcoal mb-4" data-id="element-93">
            Lo que has intentado{' '}
            <span className="text-crimson underline decoration-crimson/30" data-id="element-94">
              NO funciona
            </span>{' '}
            (y por qué)
          </h2>
          <p className="font-body text-lg text-warm-gray max-w-2xl mx-auto" data-id="element-95">
            Si sigues haciendo lo mismo, el nervio seguirá atrapado. Estos son
            los 4 errores que te mantienen en agonía:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-96">
          {mistakes.map((mistake, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-97">
              <div className="flex items-start mb-4" data-id="element-98">
                <XCircle className="w-8 h-8 text-crimson flex-shrink-0 mr-4 mt-1" data-id="element-99" />
                <h3 className="font-heading font-bold text-xl text-charcoal" data-id="element-100">
                  {mistake.title}
                </h3>
              </div>
              <p className="font-body text-warm-gray leading-relaxed pl-12" data-id="element-101">
                {mistake.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}